export const AUTH_SOURCES: [string, string][] = [
  ['M-Pesa Daraja', 'Streaming'],
  ['Core banking T24', 'Every 15 min'],
  ['Airtel Money', 'Every 5 min'],
  ['Agency portal', 'Hourly'],
  ['Card & ATM switch', 'Daily file'],
];

export function authDiagram(svg: SVGSVGElement, SRC = AUTH_SOURCES) {
  const APPS = [['Zua Insights', 'Phase 1 · Live', true], ['Zua Monitor', 'Phase 2', false], ['Zua Predict', 'Phase 3', false]];
  const hub = { x: 262, y: 110, w: 156, h: 110 };
  const cy = hub.y + hub.h / 2;
  const defs = `
    <defs>
      <linearGradient id="gFlow" x1="0" x2="1"><stop offset="0" stop-color="#F8A833"/><stop offset=".55" stop-color="#F0803E"/><stop offset="1" stop-color="#E93E39"/></linearGradient>
      <linearGradient id="gHub" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="rgba(255,255,255,.20)"/><stop offset="1" stop-color="rgba(255,255,255,.06)"/></linearGradient>
      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="6"/></filter>
    </defs>`;
  let paths = '', nodes = '', dots = '';

  SRC.forEach(([name, cad], i) => {
    const y = 18 + i * 62, w = 158, h = 44;
    const d = `M${w} ${y + h / 2} C ${w + 50} ${y + h / 2}, ${hub.x - 50} ${cy}, ${hub.x} ${cy}`;
    paths += `<path d="${d}" fill="none" stroke="rgba(255,255,255,.12)" stroke-width="1.5"/>
              <path class="flow" id="ps${i}" d="${d}" fill="none" stroke="url(#gFlow)" stroke-width="1.6" opacity=".9"/>`;
    dots += `<circle class="pulse" r="3.2" fill="#FFD08A"><animateMotion dur="${2.4 + i * .35}s" repeatCount="indefinite" begin="${i * .4}s"><mpath href="#ps${i}"/></animateMotion></circle>`;
    nodes += `
      <g><rect x="0" y="${y}" width="${w}" height="${h}" rx="11" fill="rgba(255,255,255,.07)" stroke="rgba(255,255,255,.16)"/>
      <circle cx="20" cy="${y + h / 2}" r="4" fill="${i === 4 ? '#F8A833' : '#4ADE80'}"/>
      <text x="34" y="${y + 19}" font-size="12.5" font-weight="600" fill="#fff">${name}</text>
      <text x="34" y="${y + 34}" font-size="10.5" fill="rgba(255,255,255,.6)">${cad}</text></g>`;
  });

  APPS.forEach(([name, phase, live], i) => {
    const w = 170, h = 58, x = 680 - w, y = 30 + i * 100;
    const d = `M${hub.x + hub.w} ${cy} C ${hub.x + hub.w + 50} ${cy}, ${x - 50} ${y + h / 2}, ${x} ${y + h / 2}`;
    paths += `<path d="${d}" fill="none" stroke="rgba(255,255,255,.12)" stroke-width="1.5"/>
              <path class="flow" id="pa${i}" d="${d}" fill="none" stroke="${live ? 'url(#gFlow)' : 'rgba(255,255,255,.35)'}" stroke-width="1.6"/>`;
    if (live) dots += `<circle class="pulse" r="3.2" fill="#FFD08A"><animateMotion dur="2s" repeatCount="indefinite"><mpath href="#pa${i}"/></animateMotion></circle>`;
    const ic = [
      `<path d="M${x + 16} ${y + 38}v-8M${x + 22} ${y + 38}v-14M${x + 28} ${y + 38}v-10M${x + 34} ${y + 38}v-18" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>`,
      `<path d="M${x + 14} ${y + 30}h5l3-7 5 14 3-7h6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
      `<path d="M${x + 14} ${y + 37}l7-7 5 4 9-11" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M${x + 30} ${y + 23}h5v5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/>`,
    ][i];
    nodes += `
      <g opacity="${live ? 1 : .78}">
        <rect x="${x}" y="${y}" width="${w}" height="${h}" rx="13" fill="${live ? 'rgba(255,255,255,.14)' : 'rgba(255,255,255,.06)'}" stroke="${live ? 'rgba(248,168,51,.7)' : 'rgba(255,255,255,.16)'}"/>
        <rect x="${x + 8}" y="${y + 12}" width="34" height="34" rx="9" fill="${live ? 'url(#gFlow)' : 'rgba(255,255,255,.12)'}"/>
        ${ic}
        <text x="${x + 52}" y="${y + 26}" font-size="13" font-weight="600" fill="#fff">${name}</text>
        <text x="${x + 52}" y="${y + 43}" font-size="10.5" fill="${live ? '#86EFAC' : 'rgba(255,255,255,.6)'}">${phase}</text>
      </g>`;
  });

  const hubSvg = `
    <rect x="${hub.x - 6}" y="${hub.y - 6}" width="${hub.w + 12}" height="${hub.h + 12}" rx="22" fill="#F0803E" opacity=".35" filter="url(#glow)"/>
    <rect x="${hub.x}" y="${hub.y}" width="${hub.w}" height="${hub.h}" rx="18" fill="url(#gHub)" stroke="rgba(255,255,255,.35)"/>
    <image href="img/zua-mark.png" x="${hub.x + 16}" y="${hub.y + 16}" width="30" height="35"/>
    <text x="${hub.x + 56}" y="${hub.y + 31}" font-size="14" font-weight="700" fill="#fff">Super App</text>
    <text x="${hub.x + 56}" y="${hub.y + 47}" font-size="10.5" fill="rgba(255,255,255,.65)">platform.zua.ai</text>
    <line x1="${hub.x + 16}" x2="${hub.x + hub.w - 16}" y1="${hub.y + 64}" y2="${hub.y + 64}" stroke="rgba(255,255,255,.18)"/>
    <text x="${hub.x + 16}" y="${hub.y + 84}" font-size="10.5" fill="rgba(255,255,255,.7)">Governed data</text>
    <text x="${hub.x + hub.w - 16}" y="${hub.y + 84}" font-size="10.5" font-weight="600" fill="#86EFAC" text-anchor="end">6 ready</text>
    <rect x="${hub.x + 16}" y="${hub.y + 92}" width="${hub.w - 32}" height="4" rx="2" fill="rgba(255,255,255,.14)"/>
    <rect x="${hub.x + 16}" y="${hub.y + 92}" width="${(hub.w - 32) * .86}" height="4" rx="2" fill="url(#gFlow)"/>`;

  svg.innerHTML = defs + paths + nodes + hubSvg + dots;

}